import { Component, OnDestroy, OnInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bottom-dialog',
  templateUrl: '../sharedTemplates/bottom-dialog.html',
})
export class BottomDialog implements OnInit, OnDestroy {
  isMobileView = false;
  private subscriptionsToStopOnDestroy: Subscription[] = [];

  constructor(private _UiHelper: UiHelper, public _UserHelper: UserHelper, private _router: Router) {
    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
  }

  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        if (x.w <= 990) {
          this.isMobileView = true;
          this._UiHelper.currentSlipHeaderTabSelected = 1;
        } else {
          this.isMobileView = false;
        }
      })
    );
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
